import { createContext, useContext } from 'react';
import store, { TGlobalStore } from '@store/index';

export const StoreContext = createContext(store);

const useStore = (): TGlobalStore => useContext(StoreContext);

export default useStore;
